import AgentFilterSelectInput, {
  AgentFilterSelectInputProps,
} from './agent-select';
import BankAccountFilterSelectInput, {
  BankAccountFilterSelectInputProps,
} from './bank-account-select';
import BonusPeriodSelectInput, {
  BonusPeriodSelectInputProps,
} from './bonus-period-select';
import CashAccountFilterSelectInput, {
  CashAccountFilterSelectInputProps,
} from './cash-account-select';
import CustomerFilterSelectInput, {
  CustomerFilterSelectInputProps,
} from './customer-select';
import EmployeeSelectInput, {
  EmployeeSelectInputProps,
} from './employee-select';
import GuestFilterSelectInput, {
  GuestFilterSelectInputProps,
} from './guest-select';
import ReportSelectInput, { ReportSelectInputProps } from './report-select';
import SaleTypeSelectInput, {
  SaleTypeSelectInputProps,
} from './sale-type-select';

export enum SelectTypeEnum {
  agent = 'agent',
  bank_account = 'bank_account',
  bonus_period = 'bonus_period',
  cash_account = 'cash_account',
  customer = 'customer',
  operator = 'operator',
  sales = 'sales',
  lead = 'lead',
  admin = 'admin',
  document_admin = 'document_admin',
  employee = 'employee',
  employee_id = 'employee_id',
  guest = 'guest',
  report = 'report',
  type = 'type',
}

export interface SelectProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
}

export default function Select(
  props:
    | (AgentFilterSelectInputProps & { type: SelectTypeEnum.agent })
    | (BankAccountFilterSelectInputProps & {
        type: SelectTypeEnum.bank_account;
      })
    | (BonusPeriodSelectInputProps & { type: SelectTypeEnum.bonus_period })
    | (CashAccountFilterSelectInputProps & {
        type: SelectTypeEnum.cash_account;
      })
    | (CustomerFilterSelectInputProps & { type: SelectTypeEnum.customer })
    | (GuestFilterSelectInputProps & { type: SelectTypeEnum.guest })
    | (ReportSelectInputProps & { type: SelectTypeEnum.report })
    | (EmployeeSelectInputProps & {
        type:
          | SelectTypeEnum.operator
          | SelectTypeEnum.sales
          | SelectTypeEnum.lead
          | SelectTypeEnum.admin
          | SelectTypeEnum.document_admin
          | SelectTypeEnum.employee
          | SelectTypeEnum.employee_id;
      })
    | (SaleTypeSelectInputProps & { type: SelectTypeEnum.type }),
) {
  switch (props.type) {
    case SelectTypeEnum.agent:
      return <AgentFilterSelectInput {...props} />;

    case SelectTypeEnum.bank_account:
      return <BankAccountFilterSelectInput {...props} />;

    case SelectTypeEnum.bonus_period:
      return <BonusPeriodSelectInput {...props} />;

    case SelectTypeEnum.cash_account:
      return <CashAccountFilterSelectInput {...props} />;

    case SelectTypeEnum.customer:
      return <CustomerFilterSelectInput {...props} />;
    case SelectTypeEnum.operator:
    case SelectTypeEnum.sales:
    case SelectTypeEnum.lead:
    case SelectTypeEnum.admin:
    case SelectTypeEnum.document_admin:
    case SelectTypeEnum.employee:
    case SelectTypeEnum.employee_id:
      return <EmployeeSelectInput {...props} />;
    case SelectTypeEnum.guest:
      return <GuestFilterSelectInput {...props} />;

    case SelectTypeEnum.report:
      return <ReportSelectInput {...props} />;

    case SelectTypeEnum.type:
      return <SaleTypeSelectInput {...props} />;
  }
}
